$(document).on('click', '.bn_header__menu-dropdown-selector', function () {
    let that = $(this),
        container = that.parents('.bn_header'),
        dropdown = container.find('.bn_header__menu-dropdown');

    that.toggleClass('active');
    dropdown.toggleClass('open');

    $(document).on('click', function (event) {
        if ($(event.target).closest('.bn_header__menu-dropdown-selector, .bn_header__menu-dropdown').length) return;

        that.removeClass('active');
        dropdown.removeClass('open');

        event.stopPropagation();
    });
});

$(document).ready(function () {
    $(window).resize(function() {
        let height = $(this).height() - 180,
            scroll = $('.bn_header__account-menu-dropdown-scroll');

        scroll.css('max-height', height + 'px');
    }).resize();
});

$(document).on('click', '.bn_header__account-menu', function (event) {
    if ($(event.target).closest('.bn_header__account-menu-dropdown').length) return;

    $(this).toggleClass('open');

    $(document).on('click', function (event) {
        if ($(event.target).closest('.bn_header__account-menu, .bn_header__account-menu-dropdown').length) return;

        $('.bn_header__account-menu').removeClass('open');

        event.stopPropagation();
    });
});

$(document).on('click', '.bn_header__account-notifications', function () {
    let that = $(this),
        counter = that.find('.bn_header__account-counter'),
        container = that.parents('.bn_header__account-notifications-wrapper'),
        popup = container.find('.bn_header__account-notifications-popup');

    if (container.hasClass('active')) {
        container.removeClass('active');
    } else {
        getPopupData();
    }

    function getPopupData() {
        $.ajax({
            'type': 'POST',
            'url': '/account/notice/modal',
            'success': function (data) {
                popup.html(data);

                container.addClass('active');

                updateCounter();

                updateHeight();

                initScrollbar();
            },
            'error': function () {
                console.error('Notifications popup ajax error')
            },
        });
    }

    function updateHeight() {
        $(window).resize(function() {
            let height = $(this).height() - 160,
                scroll = $('.bn_notice__wrapper[data-scrollbar]');

            scroll.css('max-height', height + 'px');
        }).resize();
    }

    function updateCounter() {
        $.ajax({
            'type': 'POST',
            'url': '/account/notice/modal-showed',
            'success': function (count) {
                if (parseInt(count) === 0) {
                    counter.remove();
                } else {
                    counter.text(count)
                }
            },
            'error': function () {
                console.error('Notifications counter ajax error')
            },
        });
    }

    $(document).on('click', function (event) {
        if ($(event.target).closest('.bn_header__account-notifications, .bn_header__account-notifications-popup').length) return;

        $('.bn_header__account-notifications-wrapper').removeClass('active');
    });
});